// TODO: Image loading & size so the scroll works first time round

import React from "react";
import Link from "gatsby-link";
import PageWrapper from "../components/PageWrapper";
import CollaboratorsGrid from "../components/CollaboratorsGrid";
import CollaboratorsList from "../components/CollaboratorsList";
import CallToAction from "../components/CallToAction";
import Helmet from "react-helmet";
import Jumbotron from "../components/Jumbotron";
import Testimonials from "../components/testimonials";
import styles from "../styles/about-us.module.scss";
import SectionTitle from "../components/SectionTitle";

import {
	Element,
	animateScroll as scroll,
	scrollSpy,
	scroller
} from "react-scroll";
import Img from "gatsby-image";


const renderResearchAreas = (array = []) => {
	return array.map(({ node }, i) => {
		return (
			<div
				key={"research-area-" + i}
				className="col-12 col-sm-6 col-md-4 col-xl-2"
			>
				<div className="row justify-content-between align-items-center">
					<div className="col-4 col-sm-12 ">
						<Link to={`/${node.node_locale}/research-areas`}>
							<Img
								title={node.featuredImage.title}
								alt={node.featuredImage.title}
								sizes={node.featuredImage.sizes}
								className="img_fill"
								style={{ marginBottom: "1rem" }}
							/>
						</Link>
					</div>
					<div
						className={
							"col-8 col-sm-12  " + styles.research_area_title_wrapper
						}
					>
						<Link to={`/${node.node_locale}/research-areas`}>
							<h4
								className={
									styles.h4 + " " + styles.research_area_title
								}
							>
								{node.title}
							</h4>
						</Link>
					</div>
				</div>
			</div>
		);
	});
};

class AboutUs extends React.Component {
	componentDidMount() {
		const hashCategory = this.props.location.hash.slice(1);

		scroller.scrollTo(hashCategory, {
			duration: 500,
			delay: 0,
			smooth: true,
			offset: -150
		});
	}

	componentDidUpdate() {
		const hashCategory = this.props.location.hash.slice(1);

		scroller.scrollTo(hashCategory, {
			duration: 500,
			delay: 0,
			smooth: true,
			offset: -150
		});
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.location.pathname !== this.props.location.pathname ||
			nextProps.location.hash !== this.props.location.hash
		);
	}

	render() {
		
		const { transition, data } = this.props;

		function isCollaborator(obj) {
			return obj.node.collaboratorType === "Collaborator";
		}
		function isFunder(obj) {
			return obj.node.collaboratorType === "Funder";
		}

		const cta = data.cta.edges[0].node;
		const researchAreas = data.researchAreas.edges;
		const { pageSettings } = data;

		const testimonials = data.testimonials.edges;
		const fundersArray = data.allContentfulCollaboratorType.edges.filter(
			isFunder
		);
		const collaboratorsArray = data.allContentfulCollaboratorType.edges.filter(
			isCollaborator
		)[0].node.organisations;

		const aboutSections = data.allContentfulAboutUs.edges;

		const items = aboutSections.map((item, i) => {
			function createMarkup() {
				return {
					__html: item.node.content.childMarkdownRemark.html
				};
			}

			return (
				<div
					key={"about-" + (i + 1)}
					className="row justify-content-start align-items-center"
				>
					<div className="col-12 col-md-4 mb-3">
						<Img
							title={item.node.featuredImage.title}
							alt={item.node.featuredImage.title}
							sizes={item.node.featuredImage.sizes}
						/>
					</div>
					<div className="col-12 col-md-7 pl-lg-5 mb-3">
						<h3 className={styles.h4}>{item.node.title}</h3>
						<div dangerouslySetInnerHTML={createMarkup()} />
					</div>
				</div>
			);
		});

		return (
			<PageWrapper
				locale={pageSettings.node_locale}
				location={this.props.location}
				data={data.layout.edges[0].node}
			>
				<main role="main" style={transition && transition.style}>
					<Helmet title={pageSettings.pageTitle + " | Mahidol Vivax Research Unit"} />
					<Element name={"mvru"} className="element">
						<Jumbotron
							bottomLine={true}
							type="jumbotron_b"
							className="mb-0"
							textAlign="text-center"
							contentAlign="justify-content-md-center"
						>
							<h1>{pageSettings.pageTitle}</h1>
						</Jumbotron>
					</Element>

					<div className="container mt-lg-5">{items}</div>

					<div className="grey_bg">
						<div className="container py-5 mt-5 mb-4">
							<Element
								name={"research-areas"}
								className="element"
							>
								<SectionTitle title={"Research Areas"} />
							</Element>

							<div className="row my-4">
								{renderResearchAreas(researchAreas)}
							</div>
						</div>
					</div>

					<div
						className="container "
						style={{
							marginTop: "-4rem",
							paddingTop: "1rem",
							background: "white"
						}}
					>
						<Element name={"funders"} className="element">
							<CollaboratorsGrid
								title={
									pageSettings.node_locale === "th"
										? "ผู้ให้ทุนสนับสนุนเรา"
										: "Our Funders"
								}
								list={fundersArray[0].node.organisations}
							/>
							{/* <p>
								MVRU research activities have been supported by Bill
								and Melinda Gates Foundation, US-NIH, US-DoD,
								Wellcome Trust, Korea-NIH, and GHIT. Our
								achievements and commitment to research are
								reflected in continuous international fundings as
								well as in peer-reviewed publications. Our
								investigators serve on several international
								scientific boards and committees.
							</p> */}
						</Element>
						{/* <hr className={styles.hr} /> */}
						<Element name={"collaborators"} className="element">
							<SectionTitle
								title={
									pageSettings.node_locale === "th"
										? "คู่ความร่วมมือกับเรา"
										: "Our Collaborators"
								}
								style={{ margin: "3rem auto 0rem" }}
							/>
						</Element>
						<div className="container my-0">
							<div className="row no-gutters justify-content-center">
								<div className="col-12 col-lg-10">
									<CollaboratorsList
										count={6}
										locale={pageSettings.node_locale}
										className={"container my-5"}
										list={collaboratorsArray}
									/>
								</div>
							</div>
						</div>
						<hr className={styles.hr} />
						<div
							className="container my-0"
							style={{
								position: "relative",
								background: "white"
							}}
						>
							<div className="row no-gutters justify-content-center">
								<div className="col-12 col-lg-10">
									<Testimonials testimonials={testimonials} />
								</div>
							</div>
						</div>
					</div>

					<div
						className="grey_bg pb-4"
						style={{ marginTop: "-3rem", paddingTop: "4rem" }}
					>
						<CallToAction
							className="my-5"
							text={cta.content.childMarkdownRemark.html}
							buttonLabel={cta.buttonLabel}
							destination={`/${pageSettings.node_locale}${
								cta.linkTo
							}`}
							arrow={true}
						/>
					</div>
				</main>
			</PageWrapper>
		);
	}
}

export default AboutUs;

export const query = graphql`
	query AboutUsQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		pageSettings: contentfulAboutPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		allContentfulAboutUs(
			filter: { node_locale: { eq: $locale } }
			sort: { order: ASC, fields: [order] }
		) {
			edges {
				node {
					id
					order
					title
					featuredImage {
						id
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							sizes
						}
						file {
							url
						}
					}
					content {
						childMarkdownRemark {
							html
						}
					}
					node_locale
				}
			}
		}

		allContentfulCollaboratorType(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					organisations {
						name
						logo {
							sizes(quality: 85) {
								...GatsbyContentfulSizes
							}
						}
						collaborator {
							name
							title
							project {
								title
								slug
							}
						}
					}
					collaboratorType
				}
			}
		}

		testimonials: allContentfulTestimony(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					author
					organisation {
						name
					}
					testimony: testimony {
						testimony
					}
				}
			}
		}

		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "aboutUs" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}

		researchAreas: allContentfulResearchArea(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					node_locale
					title
					slug
					featuredImage {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/about-us-template.js